import { render, staticRenderFns } from "./input-payment-account.vue?vue&type=template&id=2230dd18"
import script from "./input-payment-account.vue?vue&type=script&lang=js"
export * from "./input-payment-account.vue?vue&type=script&lang=js"
import style0 from "./input-payment-account.vue?vue&type=style&index=0&id=2230dd18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports